import { ThemeProvider } from '@sahinyazilim/sahinyazilim-components';
import { useAppSelector } from 'common/context/hooks';
import { store } from 'common/context/store';
import { initI18n } from 'common/i18n/I18n';
import { mainRoutes, welcomeRoute } from 'common/utils/routes';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

initI18n();

const CreateTheme = () => {
  const auth = useAppSelector((state) => state.common.auth);
  return (
    <ThemeProvider isAuth={!!auth}>
      <BrowserRouter>{auth ? mainRoutes : welcomeRoute}</BrowserRouter>
    </ThemeProvider>
  );
};

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <Provider store={store}>
      <CreateTheme />
    </Provider>
  </StrictMode>,
);
